export const SearchBarName = 'searchBarComponent';
